import { en } from "./en.js";
import { nl } from "./nl.js";
import type { Dict } from "./en.js";

export type Locale = "en" | "nl";
export type { Dict };

const dicts: Record<Locale, Dict> = { en, nl };

const STORAGE_KEY = "hanta.locale";

export function detectLocale(): Locale {
  const saved = localStorage.getItem(STORAGE_KEY) as Locale | null;
  if (saved === "en" || saved === "nl") return saved;
  const nav = navigator.language.toLowerCase();
  return nav.startsWith("nl") ? "nl" : "en";
}

export function setLocale(locale: Locale): void {
  localStorage.setItem(STORAGE_KEY, locale);
}

export function t(locale: Locale, key: string): string {
  const parts = key.split(".");
  let cur: unknown = dicts[locale];
  for (const p of parts) {
    if (cur && typeof cur === "object" && p in (cur as Record<string, unknown>)) {
      cur = (cur as Record<string, unknown>)[p];
    } else {
      return key;
    }
  }
  return typeof cur === "string" ? cur : key;
}

/** Apply translations to every element with a [data-i18n] attribute. */
export function applyI18n(locale: Locale, root: ParentNode = document): void {
  document.documentElement.setAttribute("lang", locale);
  root.querySelectorAll<HTMLElement>("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n;
    if (key) el.textContent = t(locale, key);
  });
}
